import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "modalValidationBirdSpro",
  class: "modal fade",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-labelledby": "modalValidationBirdSproMessage",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog text-start" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body py-4" }
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = { class: "fw-600 caption" }
const _hoisted_7 = { class: "mt-4" }
const _hoisted_8 = { class: "form-check text-start" }
const _hoisted_9 = { class: "modal-footer border-top-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Input = _resolveComponent("Input")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "modal-header" }, [
          _createElementVNode("h1", {
            id: "modalValidationBirdSproMessage",
            class: "modal-title fs-5"
          }, " Emissão de Certificado ")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[5] || (_cache[5] = _createElementVNode("p", { class: "fs-6" }, " Abra seu aplicativo Bird ID no seu celular e digite o código OTP referente ao CPF abaixo para prosseguir com a emissão do seu Certificado Digital. ", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Icon, {
              name: "id-card",
              class: "me-2",
              style: {"margin-top":"2px"}
            }),
            _createElementVNode("p", _hoisted_6, "CPF: " + _toDisplayString(_ctx.model.cpf), 1)
          ]),
          _createVNode(_component_Input, {
            modelValue: _ctx.model.otp,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.otp) = $event)),
            label: "OTP * (Bird ID)",
            icon: "address-card",
            placeholder: "Digite apenas números",
            "is-numeric": "",
            mask: ['### ###', ''],
            "error-log": _ctx.error
          }, null, 8, ["modelValue", "error-log"]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("input", {
                id: "default-checkbox",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.termos) = $event)),
                class: "form-check-input form-check-input--success",
                type: "checkbox"
              }, null, 512), [
                [_vModelCheckbox, _ctx.model.termos]
              ]),
              _cache[3] || (_cache[3] = _createElementVNode("span", {
                class: "form-check-label me-1 caption-small",
                for: "default-checkbox"
              }, " Li e concordo com a ", -1)),
              _cache[4] || (_cache[4] = _createElementVNode("a", {
                class: "link-info text-decoration-underline caption-small",
                href: "/PoliticadePrivacidade.pdf",
                target: "_blank"
              }, "política de privacidade ", -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            class: _normalizeClass(["btn modal-footer_btn-process", !_ctx.isValid ? 'btn-secondary' : 'btn-primary']),
            type: "button",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleNextStep && _ctx.handleNextStep(...args)))
          }, [
            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "me-2" }, "Avançar", -1)),
            _createVNode(_component_Icon, { name: "arrow-right" })
          ], 2)
        ])
      ])
    ])
  ], 512)), [
    [_vShow, true]
  ])
}